
import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadFileToOSS, GetTongueInfo, GetTextAudio } from "@/request/common";
import TipCarousel from "@/components/TipCarousel.vue";

@Component({
  components: { TipCarousel },
})
export default class TakeTongue extends Vue {
  private stream: MediaStream | null = null;
  private imageUrl: string = "";
  private isTakingPhoto: boolean = false;
  private isScanning: boolean = false;
  private videoWidth: number = 0;
  private videoHeight: number = 0;
  private uploading: boolean = false;
  private showError: boolean = false;
  private currentAudio: any = null;
  private data: any = {
    imgUrl: "",
    algo_result: {},
    deepseek_result: "",
    extra_text: "",
    report: {},
  };
  private async initCamera() {
    try {
      // 初始化摄像头
      const constraints = {
        video: {
          facingMode: "user",// 前置摄像头,environment 后置摄像头
          // width: { ideal: 2448 },
          // height: { ideal: 3264 },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      };

      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      const video = this.$refs.video as HTMLVideoElement;
      if (video) {
        video.srcObject = this.stream;
        video.onloadedmetadata = () => {
          const videoAspectRatio = video.videoWidth / video.videoHeight;
          const containerHeight = window.innerHeight * 0.6; // 60% 的视口高度
          const containerWidth = window.innerWidth - 100;

          // 根据容器尺寸和视频比例计算实际显示尺寸
          if (videoAspectRatio > containerWidth / containerHeight) {
            video.style.width = containerWidth + "px";
            video.style.height = containerWidth / videoAspectRatio + "px";
            this.videoWidth = containerWidth;
            this.videoHeight = containerWidth / videoAspectRatio;
          } else {
            video.style.height = containerHeight + "px";
            video.style.width = containerHeight * videoAspectRatio + "px";
            this.videoWidth = containerHeight * videoAspectRatio;
            this.videoHeight = containerHeight;
          }
        };
      }

      // 开始自动化流程
      await this.startAutomatedProcess();
    } catch (error) {
      console.error("摄像头初始化失败:", error);
    }
  }

  private stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
      this.stream = null;
    }
  }

  private async startAutomatedProcess() {
    // 播放提示语音
    // await this.playCountdown("请在倒计时3秒后伸出舌头进行舌诊，三、二、一");
    await new Promise((resolve) => {
      this.getTextAudio(
        "请在倒计时3秒后伸出舌头进行舌诊。三。二。一。开始拍摄。"
      ).then((data: any) => {
        this.currentAudio = new Audio(data);
        this.currentAudio.play();
        // 监听音频播放结束事件
        this.currentAudio.addEventListener("ended", () => {
          this.currentAudio = "";
          resolve("");
        });
      });
    });

    // 等待2秒后拍照
    await new Promise((resolve) => setTimeout(resolve, 2000));
    const kacaAudio: any = new Audio(
      "https://cjweb.oss-cn-shanghai.aliyuncs.com/szr/kacha.mp3"
    );
    kacaAudio.play();
    await this.takePhoto();

    await new Promise((resolve) => {
      this.getTextAudio("拍摄完成").then((data: any) => {
        this.currentAudio = new Audio(data);
        this.currentAudio.play();
        // 监听音频播放结束事件
        this.currentAudio.addEventListener("ended", () => {
          this.currentAudio = null;
          resolve(true);
        });
      });
    });
    this.uploading = true;
    // 拍照后立即上传
    await this.startUpload();
  }

  private playCountdown(val: any): Promise<void> {
    return new Promise((resolve) => {
      const text = val;
      const utterance = new SpeechSynthesisUtterance(text);

      // 设置中文语音
      const voices = window.speechSynthesis.getVoices();
      const chineseVoice = voices.find((voice) => voice.lang.startsWith("zh"));
      if (chineseVoice) {
        utterance.voice = chineseVoice;
      }

      utterance.onend = () => {
        resolve();
      };

      window.speechSynthesis.speak(utterance);
    });
  }

  private async takePhoto() {
    const video = this.$refs.video as HTMLVideoElement;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    if (ctx) {
      ctx.drawImage(video, 0, 0);
      this.imageUrl = canvas.toDataURL("image/jpeg");
    }
  }
  private reset() {
    this.data = {
      imgUrl: "",
      algo_result: {},
      deepseek_result: "",
      extra_text: "",
      report: {},
    };
    this.showError = false;
    this.imageUrl = "";
    this.initCamera();
  }
  private retake() {
    this.imageUrl = "";
    this.initCamera();
  }

  private async startUpload() {
    if (!this.imageUrl) return;
    const base64Data = this.imageUrl.split(",")[1];
    const blob = this.base64ToBlob(base64Data);
    const formData = new FormData();
    formData.append("upload_file", blob, "tongue.jpg");

    try {
      const res = await UploadFileToOSS(this, formData);
      this.data.imgUrl = res.file_url;
      await this.getTongueInfo();
    } catch (error) {
      console.error("上传失败:", error);
      this.$toast.fail("上传失败");
      this.uploading = false;
    }
  }
  private getTongueInfo() {
    const params:any = {
      params: {
        file_url: this.data.imgUrl,
        gender: this.$route.query.gender || '',
        age_group: this.$route.query.age || '',
        weight_group: this.$route.query.weight || '',
      },
    };
    if (this.$route.query.name) {
      params.params.name = this.$route.query.name;
    }
    if (this.$route.query.id_code) {
      params.params.id_code = this.$route.query.id_code;
    }
    if (this.$route.query.id_code_type) {
      params.params.id_code_type = this.$route.query.id_code_type;
    }
    if (this.$route.query.birth_date) {
      params.params.birth_date = this.$route.query.birth_date;
    }
    if (this.$route.query.phone) {
      params.params.phone = this.$route.query.phone;
    }
    GetTongueInfo(this, params)
      .then((res: any) => {
        console.log(8888);
        console.log(res);
        if (res == "失败") {
          this.uploading = false;
          this.showError = true;
        } else {
          this.data.algo_result = res.algo_result;
          this.data.deepseek_result = res.deepseek_result;
          // this.uploading = false;
          // this.$emit("uploadSuccess", this.data);
          // 文字转语音
          this.getTextAudio(res.deepseek_result).then((url: any) => {
            this.data.sheAudioUrl = url;
            // const audio = new Audio(url);
            // audio.play();
            this.uploading = false;
            this.$emit("uploadSuccess", this.data);
          });
        }
      })
      .catch((error) => {
        console.log(999999);
        this.$toast.clear();
        this.$toast.fail("获取舌诊信息失败");
        console.error(error);
        this.uploading = false;
      });
  }
  private async getTextAudio(text: string) {
    return new Promise((resolve, reject) => {
      GetTextAudio(this, {
        text: text,
      })
        .then((res: any) => {
          const base64Data = res.data;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "audio/mp3" });
          const url = URL.createObjectURL(blob);
          resolve(url);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private base64ToBlob(base64: string): Blob {
    const byteString = window.atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], { type: "image/jpeg" });
  }
  private goHome() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio = null; // 清空 currentAudio
    }
    this.$router.push("/home");
  }

  private async mounted() {
    this.initCamera();
  }

  private beforeDestroy() {
    this.stopCamera();
  }
}
